// ============================================================
// data/nav.ts — âncoras da navegação institucional
// ============================================================

export interface NavAnchor {
  id: string;
  href: string;
  label: string;
}

export const navAnchors: ReadonlyArray<NavAnchor> = [
  { id: 'manifesto', href: '#manifesto', label: 'Manifesto' },
  { id: 'audiences', href: '#para-quem-e', label: 'Para quem é' },
  { id: 'how', href: '#como-funciona', label: 'Como funciona' },
  { id: 'principles', href: '#principios', label: 'Princípios' },
  { id: 'showcase', href: '#showcase', label: 'Telas' },
  { id: 'science', href: '#ciencia', label: 'Ciência' },
  { id: 'compliance', href: '#conformidade', label: 'Conformidade' },
  { id: 'partnership', href: '#parceria', label: 'Parceria' },
];

export const APP_URL =
  (typeof import.meta !== 'undefined' && (import.meta.env?.VITE_APP_URL as string | undefined)) ||
  'https://app.lume.med.br/';
